import React, { FunctionComponent } from 'react';
import { Text } from 'react-konva';
import { GraphStyle } from '../types';
import LayoutList from './layout/LayoutList';


type Props = {
	labels: string[],
	style: GraphStyle,
	space?: number,
	align?: string,
	margin?: number,
}

const ListLabelsVert: FunctionComponent<Partial<Props>> = ({
	labels = [],
	style,
	...props
}) => {
	return <LayoutList {...props}>
		{labels.map((label, index) => (
			<Text key={index}
				listening={false}
				text={label}
				fontSize={style.bg.font.size}
				align="right"
				fill={style.bg.font.color}
				verticalAlign="middle"
			/>
		))}
	</LayoutList>
}

export default ListLabelsVert
